import { render } from "./Verification.vue?vue&type=template&id=754b6f29&scoped=true&ts=true"
import script from "./Verification.vue?vue&type=script&lang=ts"
export * from "./Verification.vue?vue&type=script&lang=ts"

import "./Verification.vue?vue&type=style&index=0&id=754b6f29&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-754b6f29"]])

export default __exports__